import { defineMessages } from 'react-intl';

export const smartLinkUnavailableMessages = defineMessages({
  title: {
    id: 'app.sml.smartLinkUnavailable.title',
    defaultMessage: 'This page does not exist or you have no access',
  },
  text: {
    id: 'app.sml.smartLinkUnavailable.text',
    defaultMessage:
      'The SmartLink is not in this workspace, or somebody deleted it. If a teammate sent you the link, switch to their workspace first.',
  },
  back: {
    id: 'app.sml.smartLinkUnavailable.back',
    defaultMessage: 'Back to SmartLinks',
  },
});
